// Hook - szczegoly Notify (deszyfrowany body HTML + plain + meta zalacznikow).
// GET /api/ui/sales-crm/notify/{id}
// Sprint 3 v4.1 (MessageModal).

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetNotifyDetailsResponse } from 'api/types/notify';

export const getNotifyDetailsQueryKey = (notifyId: number) =>
  ['sales-crm-notify', 'details', notifyId] as const;

const getNotifyDetails = (notifyId: number): Promise<IGetNotifyDetailsResponse> =>
  axios.get(`/sales-crm/notify/${notifyId}`);

export const useGetNotifyDetails = (
  notifyId: number,
  options?: UseQueryOptions<IGetNotifyDetailsResponse, IError>
) =>
  useQuery<IGetNotifyDetailsResponse, IError>(
    getNotifyDetailsQueryKey(notifyId),
    () => getNotifyDetails(notifyId),
    {
      enabled: notifyId > 0,
      staleTime: 60_000,
      ...options
    }
  );
